// @ts-nocheck

export type TicketListWithRoom = typeof TicketListWithRoom[keyof typeof TicketListWithRoom];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketListWithRoom = {
  true: 'true',
  false: 'false',
} as const;
